import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { SchoolTypeRequest } from "./SchoolTypeRequest";
import { StringRequest } from "./StringRequest";

@Injectable()
export class DataService_SchoolTypeSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadSchoolType() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/LoadSchoolType?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolTypeCDUsed(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolTypeCDUsed";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolTypeDescUsed(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolTypeDescUsed";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolTypeInsert(parms: SchoolTypeRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolTypeInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolTypeUpdateInfo(parms: SchoolTypeRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolTypeUpdateInfo";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolTypeDeleteInfo(SchoolTypeID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/SchoolTypeDeleteInfo?SchoolTypeID=" + SchoolTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
